import Instance from "./instance";

export const CreatePassword = async (payload) => {
  try {
    return await Instance.instanceToken.put("/campaign/password", payload);
  } catch (error) {
    return error;
  }
};
